import { VlGapType } from '@/interfaces/server-data';
import { FormatNumber } from '@/numberFormatter';
import { i18n } from '@/services/i18n';

export class Formatter {
  static vlGap(
    value: number | null | undefined,
    type: VlGapType | undefined,
  ): string {
    if (type !== 'RUBLES' && type !== 'PERCENT') {
      return '—';
    }
    if (value === null || value === undefined) {
      return '—';
    }
    const formatted = FormatNumber.format(value);
    if (type === 'RUBLES') {
      return `${formatted} ${i18n.t('masterData.assortment.vlGapTypeRubles')}`;
    }
    if (type === 'PERCENT') {
      return `${formatted} ${i18n.t('masterData.assortment.vlGapTypePercent')}`;
    }
    return formatted;
  }
}
